// extracted by mini-css-extract-plugin
export default {"clipi":"MailSentPage_clipi__DTotL"};